import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import CommercialProductIpr from "./CommercialProductIpr";

class Coverholder extends CommercialProductIpr {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/commercial-products-ipr';
  }
}

export default Coverholder;
